import RegisterRetailerController from "emun.auth/register-retailer.controller";
import config from "emun.auth/auth.config";
import { uuid } from "webutils/services/util";

export default class RegisterRetailerPromptController extends RegisterRetailerController {
  constructor($rootScope, $scope, options = {}) {
    super($rootScope, $scope);
    const $ctrl = this;
    //const options = resolve('options') || {};
    $ctrl.title = options.title || "Register for an account...";

    if (!$ctrl.cancelUrl) {
      $ctrl.cancelUrl = config.cancelUrl || "/";
    }
    if (!$ctrl.termsAndConditionsUrl) {
      $ctrl.termsAndConditionsUrl = config.termsAndConditionsUrl;
    }
    $ctrl.request = {
      role: "Retailer",
      autoLogin: true,
      billing: { country: "US" },
      shipping: { country: "US" },
      tags: {
        RegisterRetailer: uuid()
      },
      contact: {},
      tradeReference: {},
      bankReference: {}
    };
  }

  copyBillingToShipping() {
    const $ctrl = this;
    Object.assign($ctrl.request.shipping, $ctrl.request.billing);
  }

  submit() {
    const $ctrl = this;
    $ctrl.request.mailing = $ctrl.request.billing;
    if (!$ctrl.request.shipping.address) {
      $ctrl.request.shipping = $ctrl.request.billing;
    }
    $ctrl.bus
      .send("NewRetailerRequest.json", $ctrl.request)
		.then(res => {
			$ctrl.onRetailerRequestReceived(res.data);
			if ($ctrl.$session.isSalesManagementMode()) $ctrl.$close(res.data.retailerCreated);
		});

  }

  onUserRegistered(userRegistered, retailerRequestReceived) {
    super.onUserRegistered(userRegistered, retailerRequestReceived);
    const $ctrl = this;
    $ctrl.$close(retailerRequestReceived);
  }
}
